// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"937e9c63","787":"7ca9587c","854":"fe9ee7f6"}[chunkId] + ".chunk.js";
};